import { createReducer, updateItemInArray, updateObject } from 'helpers/ReducerUtil'
import {
  HORIZONTAL_TABLE_ADD,
  HORIZONTAL_TABLE_REMOVE,
  HORIZONTAL_TABLE_UPDATE,
  HORIZONTAL_TABLE_NESTED_ADD,
  HORIZONTAL_TABLE_NESTED_REMOVE,
  HORIZONTAL_TABLE_NESTED_UPDATE
} from './constants'

const horizontalTableAdd = (values) => [...values, {}]

const horizontalTableRemove = (values, { index }) => values.filter(
  (value, currentIndex) => index !== currentIndex
)

const horizontalTableUpdate = (values, { value, index, element }) => updateItemInArray(
  values,
  index,
  oldValue => updateObject(oldValue, { ...oldValue, [element]: value })
)

const horizontalTableNestedAdd = (values, { colKey, horizontalTableIndex }) => {
  return values.map((horizRow, i) => {
    if (i === horizontalTableIndex) {
      const nestedTableValues = horizRow[colKey]
      return !nestedTableValues ? 
      {
        ...horizRow,
        [colKey]: [
          {}
        ]
      }
      : {
        ...horizRow,
        [colKey]: [
          ...nestedTableValues,
          {}
        ]
      }
    } else {
      return horizRow
    }
  })
}


const horizontalTableNestedRemove = (values, { horizontalTableIndex, colKey, verticalTableIndex }) => {
  return values.map((x, i) => {
    if (i === horizontalTableIndex) {
      return {
        ...x,
        [colKey]: x[colKey].filter((_, idx) => idx !== verticalTableIndex)
      }
    } else {
      return x
    }
  })
}

const horizontalTableNestedUpdate = (values, { horizontalTableIndex, colKey, verticalTableIndex, nestedColKey, value }) => {
  return values.map((x, i) => {
    if (i === horizontalTableIndex) {
      console.log('Being updated', colKey, x[colKey], x)

      return {
        ...x,
        [colKey]: updateItemInArray(
          x[colKey],
          verticalTableIndex,
          oldValue => updateObject(oldValue, { ...oldValue, [nestedColKey]: value })
        )
      }
    } else {
      return x
    }
  })
}

const horizontalTableInputReducer = createReducer([], {
  [HORIZONTAL_TABLE_ADD]: horizontalTableAdd,
  [HORIZONTAL_TABLE_REMOVE]: horizontalTableRemove,
  [HORIZONTAL_TABLE_UPDATE]: horizontalTableUpdate,
  [HORIZONTAL_TABLE_NESTED_ADD]: horizontalTableNestedAdd,
  [HORIZONTAL_TABLE_NESTED_REMOVE]: horizontalTableNestedRemove,
  [HORIZONTAL_TABLE_NESTED_UPDATE]: horizontalTableNestedUpdate
})

export default horizontalTableInputReducer
